import styled from 'styled-components'
import colors from '../../../assets/colors'

export const ReportsTableStyled = styled.div`
  .planning-btn {
    margin-right: 0; /* el gap de 12 px de la barra ya separa de «Exportar» */
    color: ${colors.white};
    background-color: ${colors.orange};
    text-transform: capitalize;

    /* Deshabilitado sin campos para el informe: mismo gris que el botón de confirmar del modal */
    &.Mui-disabled {
      color: rgba(0, 0, 0, 0.26);
      background-color: rgba(0, 0, 0, 0.12);
    }
  }
  .toolbar {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;

    /* Mismo hueco (12 px, el gap de la barra) entre «Crear informe» y los botones de acción */
    .actions {
      text-transform: none;
      font-size: 14px;
      padding-left: 0;
      padding-right: 0; /* el último botón llega al borde de la tabla */
      gap: 12px;

      > button,
      > * > button {
        margin-left: 0 !important;
      }
    }
  }
  .toolbar {
    text-align: left;
    margin-bottom: 30px;
    margin-top: 0; /* el padding de la página ya da el espacio, como en candidatos */

    .MuiButton-root {
      font-size: 14px;
      padding-left: 20px;
      padding-right: 15px;
      text-transform: capitalize;
    }
  }
`
